import React from 'react';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function LanguageToggle() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="fixed top-4 right-4 z-50" data-id="element-101">
      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-white font-medium text-sm shadow-lg hover:bg-white/10 transition-colors" data-id="element-102">
        <Globe className="w-4 h-4" data-id="element-103" />
        <span data-id="element-104">{lang === 'es' ? 'ES' : 'EN'}</span>
      </motion.button>
    </div>;
}